module.exports = __webpack_public_path__ + "img/yellow-rectangle-table-8.2864ad8c.png";